import { render, staticRenderFns } from "./metadataList.vue?vue&type=template&id=5f6f3817&scoped=true&"
import script from "./metadataList.vue?vue&type=script&lang=js&"
export * from "./metadataList.vue?vue&type=script&lang=js&"
import style0 from "./metadataList.vue?vue&type=style&index=0&id=5f6f3817&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6f3817",
  null
  
)

export default component.exports